import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

//redux
import { Provider } from "react-redux";
import { store } from "./redux/store";

// CSS File Here
import "swiper/css";
import "swiper/css/effect-fade";
import "aos/dist/aos.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-modal-video/scss/modal-video.scss";
import "./assets/scss/style.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const container = document.getElementById("root");
const queryClient = new QueryClient();

const root = createRoot(container);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
      <ToastContainer />
    </Provider>
  </QueryClientProvider>
);
